import axios from 'plugins/axios'
import locales from 'plugins/wsc-locales'

export const state = {
  order: null
}

export const getters = {
  order (state) {
    return state.order
  }
}

export const mutations = {
  set (state, order) {
    state.order = order
  },
  clearOrder (state) {
    state.order = null
  }
}

export const actions = {
  async create ({state, commit, getters}, order) {
    if (getters.order) {
      order = Object.assign({}, getters.order, order)
    }

    // add locale key
    order.locale_key = locales.usedLocale

    let response = await axios.post(`/orders?id=${Math.random() * 10}`, order)

    await commit('set', response.data.data)

    return response.data.data
  },
  async monitor ({state, commit, getters}, orderId) {
    let response = await axios.get(`/orders/${orderId}/monitor?id=${Math.random() * 10}`)

    await commit('set', response.data.data)

    return response.data.data
  },
  async cancel ({state, commit, getters}, {order, payment}) {
    let request = { order: order, payment: payment }
    let response = await axios.post(`/payment-processors/cancel?id=${Math.random() * 10}`, request)

    return response.data.data
  }
}



// WEBPACK FOOTER //
// ./client/store/order.js